module.exports = __webpack_public_path__ + "img/exit.2cf8f6e1.png";